import { useOnboarding } from '../contexts/OnboardingContext';
import { useBusinessSetupStatus } from './useBusinessSetupStatus';

/**
 * O3 (SO-22) — whether the "SET UP" highlight (profile menu) / setup dot (sidebar)
 * belongs on "My Business". `useBusinessSetupStatus().isIncomplete` stays true for
 * every owner while some sections have no completion source yet, so on its own it
 * flagged live, approved salons too. The badge is a call to action, so it shows only
 * while the business is still being set up: a draft, or sent back with changes
 * requested. Approved / pending approval / suspended / unknown (still loading) → no badge.
 */
export function useSetupBadge(): boolean {
    const { businessStatus } = useOnboarding();
    const { isIncomplete } = useBusinessSetupStatus();
    const settingUp = businessStatus === 'draft' || businessStatus === 'rejected';
    return settingUp && isIncomplete;
}
